import React, { useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Table, Space, Button, Input, Tag, QRCode, Modal, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { deleletePcard } from "../store/actions/pcardAction";
import { Link } from "react-router-dom";
import "../style/cardTable.css";
import { CgEyeAlt } from "react-icons/cg";
import { FaEdit, FaQrcode } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { downloadAntdQR } from "../api/config";
import { useTranslation } from "react-i18next";
import { filterTableDate } from "../store/reducers/pcardReducer";
import dayjs from "dayjs";

const PcardsTable = ({ translate }) => {
  const { i18n } = useTranslation();
  const { cards, totalCount, totalAmount, isLoading } = useSelector(
    (state) => state.bussinesCard,
  );
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(30);
  const dispatch = useDispatch();

  const data = cards?.map((card, index) => ({
    key: card.id,
    ID: index + 1,
    id: card.id || "",
    UUID: card.UUID,
    serial: card.serial,
    branch: card.branch,
    name: i18n.language === "en" ? card.name : card.ar_name,
    ar_name: card.ar_name,
    employee: card.employee,
    count: card.count1,
    price: card.price,
    paymentType: card.paymentType,
    date: dayjs(card.createdDate).format("DD-MM-YYYY"),
  }));

  const columns = [
    {
      title: translate("TABLE.ID"),
      dataIndex: "ID",
      key: "ID",
      align: "center",
      width: 80,
    },
    {
      title: translate("FORM.SERIAL"),
      dataIndex: "serial",
      key: "serial",
      align: "center",
      width: 150,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={translate("FORM.SERIAL")}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8, display: "block" }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => {confirm();setSelectedKeys([]);}}
              size="small"
              style={{ width: 90 }}
            >
              {translate("BUTTONS.SEARCH")}
            </Button>
            <Button
              onClick={() => clearFilters()}
              size="small"
              style={{ width: 90 }}
            >
              {translate("BUTTONS.RESET")}
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) =>
        record.serial.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: translate("FORM.BRANCH"),
      dataIndex: "branch",
      key: "branch",
      align: "center",
      width: 120,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={translate("FORM.BRANCH")}
            value={selectedKeys[0]}
            onChange={(e) =>{
              setSelectedKeys(e.target.value ? [e.target.value] : []);
             
            }}
            onPressEnter={() =>{ 
                confirm();
                setSelectedKeys([]);
              }}
            style={{ marginBottom: 8, display: "block" }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() =>{ 
                confirm();
                setSelectedKeys([]);
              }
              }
              size="small"
              style={{ width: 90 }}
            >
              {translate("BUTTONS.SEARCH")}
            </Button>
            <Button
              onClick={() =>{
                clearFilters();
                confirm();
                setSelectedKeys([]);
              }}
              size="small"
              style={{ width: 90 }}
            >
              {translate("BUTTONS.RESET")}
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) =>
        record.branch.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: translate("FORM.NAME"),
      dataIndex: "name",
      key: "name",
      align: "center",
      width: 200,
    },
    // {
    //   title: translate("FORM.EMPLOYEE"),
    //   dataIndex: "employee",
    //   key: "employee",
    //   align: "center",
    //   width: 150,
    // },
    {
      title: translate("FORM.CARDDATE"),
      dataIndex: "date",
      key: "date",
      align: "center",
      width: 150,
    },
    {
      title: translate("FORM.COUNT"),
      dataIndex: "count",
      key: "count",
      align: "center",
      width: 100,
      sorter: (a, b) => a.count - b.count,
    },
    {
      title: translate("FORM.PRICE"),
      dataIndex: "price",
      key: "price",
      align: "center",
      width: 120,
    },
    {
      title: translate("FORM.PAYMENTTYPE"),
      dataIndex: "paymentType",
      key: "paymentType",
      align: "center",
      width: 150,
    },
    {
      title: translate("TABLE.ACTION"),
      key: "action",
      width: 200,
      align: "center",
      render: (_, record) => (
        <Space size="small">
          <Tag color="#1677ff" style={{ cursor: "pointer" }}>
            <Link
              to={`/card/bussines?user=${record.UUID}&branch=${record.branch}`}
            >
              <CgEyeAlt />
            </Link>
          </Tag>

          <Tag
            color="#222f3e"
            style={{ cursor: "pointer", padding: "2px 8px" }}
            onClick={() => downloadAntdQR(record.UUID, record.serial)}
          >
            <QRCode
              id={`qr-${record.UUID}`}
              value={`${process.env.REACT_APP_DOMAIN}/card/bussines?user=${record.UUID}&branch=${record.branch}`}
              style={{ display: "none" }}
            />
            <FaQrcode />
          </Tag>

          <Tag color="#00b894" style={{ cursor: "pointer" }}>
            <Link to={`/pcard/edit?id=${record.id}`}>
              <FaEdit />
            </Link>
          </Tag>

          <Tag
            color="#d63031"
            style={{ cursor: "pointer" }}
            onClick={() => {
              Modal.confirm({
                title: translate("HEADING.DELETECONFIRM"),
                centered: true,
                onOk: () => {
                  dispatch(deleletePcard(record.id))
                    .unwrap()
                    .then(() => message.success("Deleted successfully"))
                    .catch((err) => message.error(String(err)));
                },
              });
            }}
          >
            <MdDelete style={{ fontSize: 16 }} />
          </Tag>
        </Space>
      ),
    },
  ];

  return (
    <div className="card_table">
      <Table
        bordered
        loading={isLoading}
        columns={columns}
        dataSource={data}
        scroll={{ x: "max-content", y: 650 }}
        size="middle"
       onChange={(pagination, filters, sorter, extra) => {
          dispatch(filterTableDate(extra.currentDataSource));
          setPage(pagination.current);
          setPageSize(pagination.pageSize);
        }}
        pagination={{
          current: page,
          pageSize: pageSize,
          total: cards?.length,
          showSizeChanger: true,
        }}
        
        summary={() => (
          <Table.Summary fixed>
            <Table.Summary.Row
              style={{
                backgroundColor: "#f5f6fa",
                fontSize: 17,
                fontWeight: "bold",
              }}
            >
              <Table.Summary.Cell index={0} colSpan={2} align="center">
                <Tag color="red">{translate("TABLE.TOTALCOUNT")} </Tag>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={1} colSpan={3} align="center">
                <span style={{ color: "#1890ff" }}>
                  {cards ? totalCount : 0}
                </span>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={2} colSpan={2} align="center">
                <Tag color="orange"> {translate("TABLE.TOTALAMOUNT")}</Tag>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={3} colSpan={3} align="center">
                <span style={{ color: "#1890ff" }}>
                  {cards ? totalAmount : 0}
                </span>
              </Table.Summary.Cell>
            </Table.Summary.Row>
          </Table.Summary>
        )}
      />
    </div>
  );
};

export default PcardsTable;
